import { PaymentProcessorConfigurationBase } from '../payment-processor-configuration-base';

export class SquarePaymentProcessorConfiguration extends PaymentProcessorConfigurationBase {
  constructor(options?: Partial<SquarePaymentProcessorConfiguration>) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }
  }
}
